import React from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import classNames from 'classnames' 
import style from './TextInput.css'

/**
 * This TextInput field will allow you to install a function
 * to prohibit keys, validate the input, and to fire changes
 * only on a carriage return or blur.
 **/
export default class TextInput extends React.Component {
  
  static propTypes = {
    onChange : PropTypes.func,
    onFocus : PropTypes.func,
    validator : PropTypes.func,
    acceptKey : PropTypes.func,
    changeOnReturn : PropTypes.bool,
    changeOnBlur : PropTypes.bool,
    alwaysFireOnReturn : PropTypes.bool,
    placeCaretAtEnd : PropTypes.bool,
    focus : PropTypes.bool,
    hint : PropTypes.string,
    value : PropTypes.string,
    maxLength : PropTypes.number,
    size : PropTypes.number,
  }

  static defaultProps = {
    changeOnReturn : true,
    changeOnBlur : true,
    alwaysFireOnReturn : false,
    acceptKey : null, 
    validator : null
  }

  constructor( props ) {
    super( props );
    const val = this.props.value || '';
    this.input = React.createRef()
    this.state = { 
      value : val,
      error : this.isInError( val ) 
    }
  }

  componentDidMount( ) {
    if ( this.props.focus && this.input.current ) {
      setTimeout( () => {
        this.input.current && this.input.current.focus()
      }, 1 )
    }
  }

  componentWillReceiveProps( next ) {
    const val = next.value || '';
    this.setState( { 
      value : val,
      error : this.isInError( val ) 
    } );
  }

  isInError( value ) {
    if ( this.props.validator ) {
      return !this.props.validator( value );
    }
    return false;
  }

  onChange( e ) {
    const err = this.isInError( e.target.value );
    this.setState( { value : e.target.value, error : err } );
    if ( this.props.changeOnReturn == false && this.props.alwaysFireOnReturn == false && this.props.onChange ) {
      this.props.onChange( e.target.value, err );
    }
  }

  onFocus( e ) {
    if ( this.props.placeCaretAtEnd ) {
      const dom = this.input.current;
      setTimeout( () => { 
        const index = dom.value ? dom.value.length : 0;
        dom.setSelectionRange( index, index );
      }, 0 );
    }
    if ( this.props.onFocus ) {
      this.props.onFocus( e );
    }
  }

  onKeyDown( e ) {
    const rtn = e.which == 13 || e.keyCode == 13;

    if ( rtn && ( this.props.changeOnReturn || this.props.alwaysFireOnReturn ) ) {
      if ( this.props.onChange && ( this.props.alwaysFireOnReturn || e.target.value != this.props.value ) ) {
        this.props.onChange( e.target.value, this.state.error );
      }
      return;
    } 

    if ( this.props.acceptKey && this.props.acceptKey( e ) == false ) {
      e.preventDefault();
      return false
    }
  }

  onBlur( e ) {
    const val = e.target.value;

    if ( this.state && this.state.error ) {

      // Return the value
      e.target.value = this.props.value;
      const err = this.isInError( this.props.value );
      if ( this.props.allowError != true ) {
        this.setState( { value : this.props.value, error : err } );
      } else {
        const same = this.props.value == null ? val == null || val.trim() == '' : this.props.value == val
        if ( this.props.changeOnBlur && this.props.onChange && !same ) {
          this.props.onChange( val, true );
        }
      }
    } else {
      const same = this.props.value == null ? val == null || val.trim() == '' : this.props.value == val
      if ( this.props.changeOnBlur && this.props.onChange && !same ) {
        this.props.onChange( val, false );
      }
    }
  }

  render() {
    let err = false;
    if ( this.state == null || this.state.error == null ) {
      err = this.isInError( this.props.value );
    } else {
      err = this.state && this.state.error;
    }

    const cn = classNames( style.textInput, this.props.className, err ? style.error : null )
    const attr = err && { 'data-error' : err } || {}
    if ( this.props.disabled === true ) {
      attr.disabled = true
    }
    if ( this.props.onKeyDown ) {
      attr.onKeyDown = this.props.onKeyDown
    }
    return ( 
      <input 
        className={cn}
        type="text"
        autoFocus={this.props.autoFocus === true}
        ref={this.input}
        value={this.state.value || ''}
        placeholder={this.props.hint || ''}
        maxLength={this.props.maxLength}
        size={this.props.size}
        style={this.props.style}
        onChange={( e ) => { this.onChange( e ) }}
        onFocus={( e ) => { this.onFocus( e ) }}
        onKeyPress={( e ) => { this.onKeyDown( e ); }}
        onBlur={( e ) => { this.onBlur( e ); }}
        {...attr} />
    )
  }

}
